import React, { useState } from 'react';
import axios from 'axios';
import querystring from 'querystring';
import { load } from "protobufjs";
import util from 'common/util'

const API_ROOT = '';

const API = {
  autocomplete : {
    url : '/geomaster/search/v1.0/utilities/autocomplete?guid=589e0d7b-fad2-412f-2e7a-771cffe5efbe'
  },
  poi : {
    url : '/geomaster/search/v1.0/pois'
  },
  geocode : {
    url : '/geomaster/search/v1.0/utilities/geocode'
  },
  stepbystep : {
    url : '/geomaster/search/v1.0/utilities/stepbystep'
  },
  labelBox : {
    url : '/labelBox/wfs?service=WFS&version=1.1.0&request=GetFeature&outputFormat=application/json&srsname=EPSG:5179'
  }
}

const routeProto = {};
load('protoResponse.v1_5_6.proto', function (err, root) {
  routeProto.Routes = root.lookupType("com.kt.navi.connector.http.navi.v1_5_6.Routes");
});

export const getItem = (url,params,data,method='post') => {
  return new Promise((resolve, reject) => {
    axios({
      method:method,
      url : `${API_ROOT}${API[url].url}${params}`,
      data : data,
      responseType: 'json',
    }).then(res => {
        if(res && res.data && res.data.pois){
          let pois = res.data.pois
          pois.some((poi) => {
            poi.point['poiId'] = poi.id
            poi.point['time'] = util.getFormatDate(new Date())
            if(poi.routeOptimization && poi.routeOptimization.multipleEntrance){
              poi.point['multipleEntrance'] = poi.routeOptimization.multipleEntrance
            }
          })
        }
        resolve(res);
    }).catch(err => reject(err));
  });
}

export const getRouteItem = (data) => {
  return new Promise((resolve, reject) => {
    axios.post('/geomaster/sdk/route/v1.56', querystring.stringify(data), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, responseType: 'arraybuffer'})
    .then( response => { 
        var bufView = new Uint8Array(response.data);
        var routes = routeProto.Routes.decode(bufView)
        if (routes && routes.routes && routes.routes.length > 0) {
          routes.routes.forEach((route, idx) => {
            util.tbtDisplayName(route.tbts, data.startName, data.endName)
          })
          resolve(routes);
        }
    })
    .catch(err => reject(err));
  });
}


export const useFetch = () => {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const doFetch = async (url) => {
    try {
      const { data } = await axios.get(url);
      setPayload(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { doFetch, error, loading, payload };
};
